export default "__VITE_ASSET__Ca_em_mH__"